<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row d-print-none">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Detaylı Arama</h4>
            <form class="repeater" @submit.prevent="get">
              <div data-repeater-list="group-a">
                <div class="row">
                  <div class="col-sm-2">
                    <b-form-group
                        label="Başlangıç Tarihi"
                        label-for="input-1"
                    >
                      <b-form-datepicker  v-model="startDate" class="mb-2"></b-form-datepicker>
                    </b-form-group>
                  </div>
                  <div class="col-sm-2">
                    <b-form-group
                        label="Bitiş Tarihi"
                        label-for="input-1"
                    >
                      <b-form-datepicker  v-model="endDate" class="mb-2"></b-form-datepicker>
                    </b-form-group>
                  </div>
                  <div class="form-group col-sm-2">
                    <label>IBAN</label>
                    <input
                        type="text"
                        v-model="account_number"
                        class="form-control"
                    />
                  </div>
                  <div class="form-group col-sm-2">
                    <label>İsim Soyisim</label>
                    <input
                        type="text"
                        v-model="name"
                        class="form-control"
                    />
                  </div>
                  <div class="form-group col-sm-2">
                    <label>API TRX</label>
                    <input
                        type="text"
                        v-model="trx"
                        class="form-control"
                    />
                  </div>
                  <div class="form-group col-sm-2">
                    <label>Ödeme Durumu</label>
                    <b-select :options="statusData" v-model="status_id "></b-select>
                  </div>
                  <div class="form-group col-sm-2">
                    <label>İşlem Yapan Kull.</label>
                    <v-select :options="admins" v-model="admin_id "></v-select>
                  </div>

                  <div class="col-lg-2 align-self-center">
                    <b-button-group>
                      <b-button variant="info" type="submit" class="btn-sm"> <i class="fa fa-search" /> Ara</b-button>
                      <b-button variant="danger" @click="clearSearchForm" class="btn-sm"> <i class="fa fa-trash" /> Sıfırla</b-button>
                    </b-button-group>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <b-alert variant="info" show="" v-if="!startDate || !endDate"> Bugüne ait ödemeler listelenmektedir.</b-alert>
      </div>
    </div>
    <div class="row">
          <div class="col-md-12">
              <b-card>
                  <b-table :items="sitesStatistics"
                           :fields="siteFields"
                           responsive="sm"
                           show-empty
                           striped
                  >
                      <template v-slot:empty="">
                          <b-alert show variant="warning">
                              Kayıt bulunamadı.
                          </b-alert>
                      </template>
                      <template v-slot:cell(approvedTotal)="data">
                          {{data.item.approvedTotal | currency}} TL
                      </template>


                  </b-table>
              </b-card>
          </div>
      </div>
    <div class="row">
      <div class="col-md-4">
        <b-card>
          <b-card-header>Onaylanan Çekimler</b-card-header>
          <b-card-body>{{ approvedAmount | currency }} TL</b-card-body>
        </b-card>
      </div>
      <div class="col-md-4">
        <b-card>
          <b-card-header>Red Edilen Çekimler</b-card-header>
          <b-card-body>{{ declinedAmount | currency }} TL</b-card-body>
        </b-card>
      </div>
      <div class="col-md-4">
        <b-card>
          <b-card-header>Bekleyen Çekimler</b-card-header>
          <b-card-body>{{ waitingAmount | currency }} TL</b-card-body>
        </b-card>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
           <div class="card-body">
           <h5 class="card-header d-flex justify-content-between align-items-center d-print-none">
              İşlemler
              <b-button-group class="float-left">
                  <download-excel
                          :data="tableData"
                          :fields="excelFields"
                          type="xls"
                          v-if="!loading"
                          :before-generate = "excel"
                  >
                      <b-button variant="success" show v-if="!loading" class="btn btn-sm"> <i class="fa fa-file-excel"></i> Excel </b-button>
                  </download-excel>
              </b-button-group>
            </h5>
            <div class="table-responsive mb-0" >
              <b-table
                  :items="tableData"
                  :fields="fields"
                  responsive="sm"
                  :busy="loading"
                  show-empty
                  striped
              >
                <template v-slot:table-busy>
                  <div class="text-center text-white my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Yükleniyor..</strong>
                  </div>
                </template>
                <template v-slot:empty="">
                  <b-alert show variant="warning">
                    Kayıt bulunamadı.
                  </b-alert>
                </template>
                <template v-slot:cell(name)="data">
                  <div @click="$store.dispatch('getCopy', {text: data.item.name, state: true})">
                    {{ data.item.name }} <i class="fas fa-copy"></i>
                  </div>
                </template>
                <template v-slot:cell(iban)="data">
                  <div @click="$store.dispatch('getCopy', {text: data.item.iban, state: true})">
                    <b-badge>{{ data.item.iban }} <i class="fas fa-copy"></i></b-badge>
                  </div>
                </template>
                <template v-slot:cell(amount)="data">
                  {{data.item.amount | currency}} TL
                </template>
                <template v-slot:cell(date)="data">
                  {{data.item.date | formatDate}}
                </template>
                <template v-slot:cell(site_id)="data">
                  <strong>
                    {{ data.item.site_detail.site_name }}
                  </strong>
                </template>
                <template v-slot:cell(api)="data">
                  <b-badge >TRX: <code class="text-success">{{ data.item.trx }} <i class="fa fa-copy" @click="$store.dispatch('getCopy', {text: data.item.trx, state: true})"></i></code> </b-badge>
                </template>
                <template v-slot:cell(status)="data">
                    <div v-if="data.item.view">
                        <b-badge variant="primary" v-if="data.item.status === '0'">
                            Onay Bekliyor.
                        </b-badge>
                        <b-badge variant="success" v-if="data.item.status === '1'">
                            Onaylandı.
                        </b-badge>
                        <b-badge variant="danger" v-if="data.item.status === '2'">
                            Red Edildi.
                        </b-badge>
                        <b-badge variant="info" v-if="data.item.status === '3'">
                            <i class="fas fa-hourglass-start"></i> İşlem Sırasına Alındı
                        </b-badge>
                        <br v-if="data.item.view && data.item.status === '3' || data.item.status === '0'">
                        <b-badge variant="primary" v-if="data.item.view && data.item.status === '3' || data.item.status === '0'"><i class="fas fa-eye"></i> {{ data.item.viewer_detail.username }} INCELIYOR </b-badge>
                        <br v-if="data.item.view && data.item.status === '3' || data.item.status === '0'">
                        <button class="btn btn-outline-warning btn-sm" v-if="data.item.view && ( data.item.status === '3' || data.item.status === '0') && (data.item.viewer_id === user_id || group_id === '6')" @click="viewCancelWithdraw(data.item.id)"> <i class="fas fa-eye-slash"></i> VAZGEÇ </button>
                        <br v-if="data.item.status === '2'">
                        <b-badge v-if="data.item.status === '2' || data.item.status === '1'">
                            {{ data.item.message }}
                        </b-badge>
                    </div>
                    <div v-else>
                        <button class="btn btn-primary btn-sm" @click="viewWithdraw(data.item.id)"> <i class="fas fa-eye"></i> INCELE</button>
                    </div>
                </template>
                <template v-slot:cell(user_id)="data">
                  <b-button-group v-if="data.item.status === '0' && data.item.view && data.item.viewer_id === user_id">
                    <b-button class="btn-sm" variant="success" v-b-tooltip:v-b-hover title="Onayla" @click="approve(data.item.id)">
                      <i class="fas fa-check"></i>
                    </b-button>
                    <b-button class="btn-sm" variant="danger" v-b-tooltip:v-b-hover title="Sil" @click="decline(data.item.id)">
                      <i class="fas fa-trash"></i>
                    </b-button>
                  </b-button-group>
                  <b-button-group v-if="data.item.manual && data.item.status === '3'  && data.item.view && data.item.viewer_id === user_id">
                    <b-button class="btn-sm" variant="success" v-b-tooltip:v-b-hover title="Onayla" @click="approveManual(data.item.id)">
                      <i class="fas fa-check"></i>
                    </b-button>
                    <b-button class="btn-sm" variant="danger" v-b-tooltip:v-b-hover title="Sil" @click="decline(data.item.id)">
                      <i class="fas fa-trash"></i>
                    </b-button>
                  </b-button-group>

                  <div v-if="data.item.edit_user > 0">
                    {{ data.item.editor_detail.username }} <br>
                    <b-badge>{{data.item.update_date | formatDate}}</b-badge>
                  </div>
                  <div v-else>
                    <b-badge variant="info">ANINDA OTOMATİK</b-badge> <br>
                    <b-badge>{{data.item.update_date | formatDate}}</b-badge>
                  </div>

                </template>

              </b-table>
            </div>
            <div class="row d-print-none">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Withdraw></Withdraw>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import depositService from "@/services/depositService";
import Withdraw from "@/components/modals/deposits/Withdraw";
import bankAccountsService from "@/services/bankAccountsService";

export default {
  page: {
    title: "Para Çekme İşlemleri",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Withdraw },
  data() {
    return {
      trx: '',
        group_id: this.$store.getters.group_id,
      apiResponse: {notification_url: '', message: ''},
      readId: 0,
      title: "Para Çekme İşlemleri",
      items: [
        {
          text: "Anasayfa",
          to: "/"
        },
        {
          text: "Para Çekme İşlemleri",
          active: true
        }
      ],
      name : '',
      fields: [
        {key: 'id', label: 'ID', sortable: false },
        {key: 'status', label: 'Durum', sortable: false },
        {key: 'site_id', label: 'Site', sortable: true },
        {key: 'bank_name', label: 'Banka', sortable: true },
        {key: 'name', label: 'İsim Soyisim', sortable: true },
        {key: 'tc', label: 'T.C Kimlik', sortable: true },
        {key: 'iban', label: 'IBAN', sortable: true },
        {key: 'amount', label: 'Tutar', sortable: true },
        {key: 'date', label: 'Tarih', sortable: false },
        {key: 'api', label: 'API', sortable: false },
        {key: 'user_id', label: '#', sortable: false },
      ],
      id: '',
      tableData: [],
      totalRows: 0,
      loading: true,
      perPage : 0,
      currentPage: 1,
      tabStatus : 'waiting_site',
      site_id: '',
      sites: [],
      startDate: this.$route.query.start_date,
      endDate: this.$route.query.end_date,
      answerMessages: [],
      api_trx: '',
      account_name: '',
      account_number: this.$route.query.account_number,
      admins: [],
      admin_id: '',
      approvedTotal: 0,
      approvedAmount: 0,
      declinedAmount: 0,
      waitingAmount: 0,
      manualTotal: 0,
      manualAmount: 0,
      mailTotal: 0,
      mailAmount: 0,
        siteStatistics: [],
        sitesStatistics: [],
      payment_type: '',
      bank_name: '',
      statusData: [
        {
          value: '',
          text: 'Tümü'
        },
        {
          value: '3',
          text: 'Bekleyen'
        },
        {
          value: '1',
          text: 'Onaylanan'
        },
        {
          value: '2',
          text: 'Red Edilen'
        }
      ],
      status_id: '',
      siteFields: [
          {key: 'site_name', label: 'Site', sortable: false },
          {key: 'approvedTotal', label: 'Başarılı ', sortable: false },
        ],
        user_id: this.$store.getters.user_id,
        excelFields: {}
    };
  },
  methods: {
    get() {
      this.getSiteStatistics()
      this.loading = true
      this.tableData = []
      let admin_id = ''
      if(this.admin_id)
         admin_id = this.admin_id.value

      depositService.withdrawals({trx: this.trx, status_id: this.status_id, admin_id: admin_id, iban: this.account_number ,page: this.currentPage, startDate: this.startDate, endDate: this.endDate, name: this.name, bank_name: this.bank_name})
      .then((res) => {
        this.loading = false
        if(res.state){
          this.tableData =  res.data
          this.page = res.page
          this.totalRows = res.rows
          this.perPage = res.perPage
        }else{
          this.$store.dispatch('getConfirmMessage', {show: true, icon: 'error', title: 'Ops!', message: res.message})
        }
      })
    },
    getDetail(id){
      this.getSiteStatistics()
      let itemIndex = this.tableData.findIndex(e => e.id === id)
      if(itemIndex > -1){
        this.tableData.splice(itemIndex, 1);
      }else{
          this.$store.dispatch('getPlayNotification', true)
      }

      depositService.withdraw({id: id})
          .then((res) => {
            if(res.state){
              this.tableData.unshift(res.data[0])
            }else{
              this.$store.dispatch('getConfirmMessage', {show: true, icon: 'error', title: 'Ops!', message: res.message})
            }
          })
    },
    clearSearchForm() {
      this.startDate = ''
      this.endDate = ''
      this.name = ''
      this.account_number  = ''
      this.bank_name = ''
      this.status_id = ''

    },
    getAdmins() {
      depositService.getAdministrators()
          .then((res) => {
            if(res.state){
              res.data.map(user => {
                this.admins.push({
                  value: user.id,
                  label: user.username
                })
              })
            }
          })

    },
    messages() {
      bankAccountsService.answersWithdrawal()
          .then((res) => {
            if(res.state)
              res.data.map((msg) => {
                this.answerMessages.push(msg.text)
              })
          })
    },
    getSiteStatistics() {
        this.getSitesStatistics()
      this.approvedAmount = 0
      this.declinedAmount = 0
      this.waitingAmount = 0
      let admin_id = ''
      if(this.admin_id)
        admin_id = this.admin_id.value
      depositService.withdrawalsCount({  admin_id: admin_id ,name: this.name, iban: this.account_number, site_id: this.site_id ,page: this.currentPage,  id: this.id, startDate: this.startDate, endDate: this.endDate, bank_name: this.bank_name})
          .then((res) => {
            if(res.state){
              this.approvedAmount = res.approvedAmount
              this.declinedAmount = res.declinedAmount
              this.waitingAmount = res.waitingAmount
            }else{
              this.$store.dispatch('getConfirmMessage', {show: true, icon: 'error', title: 'Ops!', message: res.message})
            }
          })
    },
    getSitesStatistics() {
          this.siteStatistics = 0
          let admin_id = ''
          if(this.admin_id)
              admin_id = this.admin_id.value
          depositService.withdrawSiteStatistics({payment_type: this.payment_type, admin_id: admin_id ,account_name: this.account_name, account_number: this.account_number,  name: this.name, site_id: this.activatedSites ,page: this.currentPage,  id: this.id, startDate: this.startDate, endDate: this.endDate, api_trx: this.api_trx})
              .then((res) => {
                  if(res.state){
                      this.sitesStatistics = res.data

                  }else{
                      this.$store.dispatch('getConfirmMessage', {show: true, icon: 'error', title: 'Ops!', message: res.message})
                  }
              })
      },
    approved(item){
      const findIndex = this.tableData.findIndex(e => e.id === item)
      const name = this.tableData[findIndex].name
      const site_detail = this.tableData[findIndex].site_detail
      const amount = this.tableData[findIndex].amount

      this.$swal({
        title: "Çekim talebi onaylanacaktır, emin misiniz?",
        html: "<code> İşlem geri alınamaz. </code> <br>" +
            "<br> <label ><i class='fas fa-globe'></i> "+site_detail.site_name+"</label>" +
            "<br> <label ><i class='fas fa-user'></i> "+name+"</label>" +
            "<br> <label ><i class='fas fa-money-bill'></i> "+amount+" TL</label>",
        icon: 'success',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: "Gönder",
        cancelButtonText: "Vazgeç"
      }).then((result) => {
        if(result.value){
          depositService.approveWithdraw({id: item})
              .then((res) => {
                if(res.state){
                  this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show:true, icon: 'success', title: 'Kaydedildi.', message: ''})
                }else{
                  this.$store.dispatch('getConfirmMessage', {show:true, icon: 'error', title: 'Ops!', message: res.message})
                }
              })

        }
      })
    },
    approveOld(item){
      const findIndex = this.tableData.findIndex(e => e.id === item)
      const name = this.tableData[findIndex].name
      const site_detail = this.tableData[findIndex].site_detail
      const amount = this.tableData[findIndex].amount

      this.$swal({
        title: "Çekim talebi onaylanacaktır, emin misiniz?",
        html: "<code> İşlem geri alınamaz. </code> <br>" +
            "<br> <label ><i class='fas fa-globe'></i> "+site_detail.site_name+"</label>" +
            "<br> <label ><i class='fas fa-user'></i> "+name+"</label>" +
            "<br> <label ><i class='fas fa-money-bill'></i> "+amount+" TL</label>",
        icon: 'success',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: "Gönder",
        cancelButtonText: "Vazgeç"
      }).then((result) => {
        if(result.value){
          depositService.approveWithdrawManual({id: item})
              .then((res) => {
                if(res.state){
                  this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show:true, icon: 'success', title: 'Kaydedildi.', message: ''})
                }else{
                  this.$store.dispatch('getConfirmMessage', {show:true, icon: 'error', title: 'Ops!', message: res.message})
                }
              })

        }
      })
    },
    decline(item){

          const findIndex = this.tableData.findIndex(e => e.id === item)
          const name = this.tableData[findIndex].name
          const site_name = this.tableData[findIndex].site_detail
          const amount = this.tableData[findIndex].amount
          this.$swal({
              title: "Çekim talebini iptal etmek istediğinize emin misiniz?",
              html: "<label ><i class='fas fa-globe'></i> "+site_name.site_name+"</label>" +
                  "<br> <label ><i class='fas fa-user'></i> "+name+"</label>" +
                  "<br> <label ><i class='fas fa-money-bill'></i> "+amount+" TL</label>" +
                  "<br>" +
                  "<input type='text' class='form-control' id='answer' placeholder='İptal sebebini belirtin' />",
              icon: 'warning',
              input: 'select',
              inputPlaceholder: 'veya hazır seçin',
              inputOptions: this.answerMessages,
              inputAttributes: {
              },
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: "Gönder",
              cancelButtonText: "Vazgeç",
          })
              .then((msg) => {
                  if(!msg.dismiss){
                      let message = ''
                      if(msg.value){
                          message = this.answerMessages[msg.value]
                      }else{
                          message = document.getElementById("answer").value
                      }
                      depositService.declineWithdraw({id: item, message: message})
                          .then((res) => {
                              if(res.state){
                                  this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show:true, icon: 'success', title: 'Kaydedildi.', message: ''})
                              }else{
                                  this.$store.dispatch('getConfirmMessage', {show:true, icon: 'error', title: 'Ops!', message: res.message})
                              }
                          })
                  }
              })
      },
      approveManual(item){

          const findIndex = this.tableData.findIndex(e => e.id === item)
          const name = this.tableData[findIndex].name
          const site_name = this.tableData[findIndex].site_detail
          const iban = this.tableData[findIndex].iban
          const amount = this.tableData[findIndex].amount
          this.$swal({
              title: "Çekim talebini onaylamak istediğinize emin misiniz?",
              html: "<label ><i class='fas fa-globe'></i> "+site_name.site_name+"</label>" +
                  "<br> <label ><i class='fas fa-user'></i> "+name+"</label>" +
                  "<br> <label ><i class='fas fa-money-bill'></i> "+amount+" TL</label>" +
                  "<br> <label ><i class='fas fa-university'></i> "+iban+"</label>" +
                  "<br>" +
                  "<input type='text' class='form-control' id='answer' placeholder='Açıklama girin' />",
              icon: 'success',
              input: 'select',
              inputPlaceholder: 'veya hazır seçin',
              inputOptions: this.answerMessages,
              inputAttributes: {
              },
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: "Gönder",
              cancelButtonText: "Vazgeç",
          })
              .then((msg) => {
                  if(!msg.dismiss){
                      let message = ''
                      if(msg.value){
                          message = this.answerMessages[msg.value]
                      }else{
                          message = document.getElementById("answer").value
                      }
                      depositService.approveWithdrawManual({id: item, message: message})
                          .then((res) => {
                              if(res.state){
                                  this.$store.dispatch('getNotifyMessage', {siteConfirm: true, show:true, icon: 'success', title: 'Kaydedildi.', message: ''})
                              }else{
                                  this.$store.dispatch('getConfirmMessage', {show:true, icon: 'error', title: 'Ops!', message: res.message})
                              }
                          })
                  }
              })
      },
      viewWithdraw(item){
          depositService.viewWithdraw({id: item})
      },
      viewCancelWithdraw(item){
          depositService.viewCancelWithdraw({id: item})
      },
      excel() {
          let excelData = Object()
          excelData['ID'] = 'id'
          excelData["BANKA"] = 'bank_name'
          excelData["ALICI İSİM"] = 'name'
          excelData["TC. NO"] = 'tc'
          excelData["IBAN"] = 'iban'
          excelData["TUTAR"] = 'amount'
          excelData["TARİH"] = {
              callback: (value) => {
                  return `${this.$options.filters.formatDate(value.update_date)}`;
              }
          }
          excelData["DÜZENLEYEN"] = 'editor_detail.username'
          excelData["ÇEKİM DURUMU"] = 'status'
          this.excelFields = excelData
      },
  },
  created() {
    this.get()
    this.getAdmins()
    this.messages()
  },
  watch: {
    currentPage: function () {
      this.get()
    },
    tabStatus: function () {
      this.get()
    },
    refresh: function () {
      if(this.refresh){
        this.get()
        this.$store.dispatch('getRefresh', false)
      }
    },
    '$store.getters.getRefresh': function() {
      this.refresh = this.$store.getters.getRefresh
    },
    '$store.getters.newData': function() {
      if(this.$store.getters.newData)
      {
        let page = this.$store.getters.newData.page
        if(page === 'withdraw'){
          this.getDetail(this.$store.getters.newData.withdraw_id)
        }
      }
    }
  }
};
</script>